import { Icons, options } from "../../../types"

import Icon from "../icon/icon"
import { Link } from "react-bricks/frontend"
import React from "react"
import classNames from "classnames"
import { twMerge } from "tailwind-merge"

export enum ButtonStyle {
    Primary = "primary",
    Secondary = "secondary",
    Ghost = "ghost",
    White = "white",
}

export enum ButtonSize {
    Small = "sm",
    Base = "base",
}

interface CommonButtonProps {
    title: string
    icon?: Icons
    style?: ButtonStyle
    size?: ButtonSize
    className?: string
    disabled?: boolean
    fullWidth?: boolean
    href?: string
    target?: string
    withOnClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

type ButtonProps = CommonButtonProps

const Button = ({
    href,
    target,
    title,
    icon,
    style = ButtonStyle.Primary,
    size = ButtonSize.Base,
    onClick,
    withOnClick,
    className,
    disabled,
    fullWidth,
}: ButtonProps) => {
    const classes = twMerge(
        classNames("w-full sm:w-auto h-14 items-center justify-center rounded-sm px-5 md:px-10 text-base", {
            "bg-blue text-white focus:outline-offset-2": style === ButtonStyle.Primary,
            "border border-blue border-solid text-blue": style === ButtonStyle.Secondary,
            "border border-white border-solid text-white": style === ButtonStyle.Ghost,
            "bg-white font-semibold text-blue": style === ButtonStyle.White,
            "cursor-not-allowed pointer-events-none opacity-30": disabled,
            "xl:h-19 xl:rounded-base xl:text-lg": size === ButtonSize.Base,
            flex: fullWidth,
            "inline-flex": !fullWidth,
        }),
        className
    )

    const innerContent = (
        <>
            {icon && <Icon icon={icon} className="mr-2.5 lg:mr-3" />}
            <span>{title}</span>
        </>
    )

    return onClick ? (
        <button type="button" className={classes} onClick={onClick} disabled={disabled}>
            {innerContent}
        </button>
    ) : disabled ? (
        <div className={classes}>{innerContent}</div>
    ) : href ? (
        <Link href={href} onClick={withOnClick} target={target} className={classes}>
            {innerContent}
        </Link>
    ) : null
}

export const buttonStyleOptions = options<typeof ButtonStyle>(ButtonStyle)

export default Button
